var map = {
	"./pages/photos/Uberstein и Константин Ремизов Bannerlord/Uberstein/1.png": 6783,
	"./pages/photos/Uberstein и Константин Ремизов Bannerlord/Константин Ремизов/1.png": 3746,
	"./pages/photos/Диоген без бочки и mitreshell Minecraft/mitreshell/1.png": 8373,
	"./pages/photos/Диоген без бочки и mitreshell Minecraft/Диоген без бочки/1.png": 5102
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9785;